export default theme => ({
  chipContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 4
  },
  chipIcon: {
    transform: 'scale(0.75)',
    marginLeft: -4,
    '& *[fill]': {
      fill: theme.colors.actionMinor[550]
    }
  }
});